import { Component, OnInit } from '@angular/core';
import { BaseClass } from '../../../../../../shared/base-class';
import { SuspendedPaymentsLabel } from '../../../../../../shared/constants/suspended-payments.labels.constants';
import { ErrorMessageConstant } from '../../../../../../shared/constants/error-message.constants';
import { SuspendedPaymentsData } from '../../../../data/suspended-payments.data';
import { BsModalRef } from 'ngx-bootstrap';
import { FormGroup } from '@angular/forms';
import { SuspendedPaymentDetailsDTO } from '../../../../../../shared/models/data/dto/suspended-payment/suspended-payment-detail.dto';

@Component({
  selector: 'app-britecore-details-suspended-payment-modal',
  templateUrl: './britecore-details-suspended-payment-modal.component.html',
  styleUrls: ['./britecore-details-suspended-payment-modal.component.scss']
})
export class BritecoreDetailsSuspendedPaymentModalComponent extends BaseClass implements OnInit {
  public SuspendedPaymentsLabel = SuspendedPaymentsLabel;
  public ErrorMessageConstant = ErrorMessageConstant;

  paymentDetail: SuspendedPaymentDetailsDTO;
  isEdit: boolean = false;

  constructor(
    public suspendedPaymentsData: SuspendedPaymentsData,
    private bsModalRef: BsModalRef
  ) {
    super();
  }

  ngOnInit() {
    this.populateFields();
  }

  get updateSuspendedForm(): FormGroup {
    return this.suspendedPaymentsData.updateSuspendedFormGroup;
  }

  hideModal(): void {
    this.bsModalRef.hide();
    this.suspendedPaymentsData.resetDocumentVariables();
    this.suspendedPaymentsData.resetUpdateSuspendedForm();
  }

  populateFields(): void {
    this.initUpdateSuspendedForm();
  }

  initUpdateSuspendedForm(): void {
    this.updateSuspendedForm.get('policyNumber').setValue(this.paymentDetail.policyNumber);
    this.updateSuspendedForm.get('payerFirstName').setValue(this.paymentDetail.payer?.firstName);
    this.updateSuspendedForm.get('payerMiddleInitial').setValue(this.paymentDetail.payer?.middleName);
    this.updateSuspendedForm.get('payerLastName').setValue(this.paymentDetail.payer?.lastName);
    this.updateSuspendedForm.get('address1').setValue(this.paymentDetail.payer?.address1);
    this.updateSuspendedForm.get('address2').setValue(this.paymentDetail.payer?.address2);
    this.updateSuspendedForm.get('city').setValue(this.paymentDetail.payer?.city);
    this.updateSuspendedForm.get('state').setValue(this.paymentDetail.payer?.state);
    this.updateSuspendedForm.get('zipCode').setValue(this.paymentDetail.payer?.zip);
  }
}
